import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import { accordion, accordionType } from 'features/bot-builder/constants';
import { Apps } from 'constants/global';
import {
  blogWriterFaqs,
  botBuilderFaqs,
  chatWithDocsFaqs,
  emailGeneratorFaqs,
  textToLogoFaqs,
  generalFaqs,
  transcriptGeneratorFaqs,
  textToSpeechFaqs,
  upscaleImageFaqs,
  objectRemoverFaqs,
  objectReplacerFaqs,
  brandbookFaqs,
  socialMediaFaqs,
  podcastFaqs,
  textToImageFaqs,
  imageToImageFaqs,
} from 'constants/faq.constant';

const accordionMap: Record<Apps, accordionType[]> = {
  [Apps.BOT_BUILDER]: botBuilderFaqs,
  [Apps.CHAT_WITH_DOCS]: chatWithDocsFaqs,
  [Apps.TEXT_TO_IMAGE]: textToImageFaqs,
  [Apps.TEXT_TO_LOGO]: textToLogoFaqs,
  [Apps.TEXT_TO_SPEECH]: textToSpeechFaqs,
  [Apps.BLOG_WRITER]: blogWriterFaqs,
  [Apps.EMAIL_GENERATOR]: emailGeneratorFaqs,
  [Apps.STICKER_MAKER]: upscaleImageFaqs,
  [Apps.GIF_MAKER]: generalFaqs,
  [Apps.TRANSCRIPT_GENERATOR]: transcriptGeneratorFaqs,
  [Apps.OBJECT_REMOVER]: objectRemoverFaqs,
  [Apps.OBJECT_REPLACER]: objectReplacerFaqs,
  [Apps.BRANDBOOK]: brandbookFaqs,
  [Apps.PODCAST]: podcastFaqs,
  [Apps.SOCIAL_MEDIA]: socialMediaFaqs,
  [Apps.UPSCALE_IMAGE]: upscaleImageFaqs,
  [Apps.IMAGE_TO_IMAGE]: imageToImageFaqs,
};

const QuestionAccordion = ({ appType }: { appType: Apps }) => {
  const [openKey, setOpenKey] = useState<string | null>();

  const accordion = accordionMap[appType];

  return (
    <Accordion
      transition
      transitionTimeout={250}
      onStateChange={({ key, current }) => {
        if (current.isResolved) {
          setOpenKey(current.isEnter ? (key as string) : null);
        }
      }}
    >
      {accordion.map(({ question, answer }: accordionType, i: number) => {
        const itemKey = `Item-${i + 1}`;
        const isOpen = openKey === itemKey;

        return (
          <AccordionItem
            className="bg-background text-text-placeholder !px-4 md:!px-6"
            header={
              <>
                <span className="text-base font-semibold md:text-xl text-start">
                  {question}
                </span>
                {isOpen ? <Minus /> : <Plus />}
              </>
            }
            key={i}
            itemKey={itemKey}
          >
            <span className="text-text-secondary">{answer}</span>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default QuestionAccordion;
